import { HOST_TULUM, API } from '@/utils/http'

export const fetchLayers = async ({commit}, payload) => {
  const response = await API({
    method: 'GET',
    url: `${HOST_TULUM}/layers/${payload.org_id}`
  })

  console.log(response.data)

  // commit('SET_LAYERS', layers)
}
